import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6153924d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default" }
const _hoisted_2 = { class: "page-path path-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "authors" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "page-title" }
const _hoisted_8 = { class: "albums" }

import movieAuthors, { State } from '@/store/movies/authors';
import Avatar from '@/views/components/Avatar.vue';
import * as links from '@/views/links';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Album from '../albums/Album.vue';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const data = computed<State>(() => store.state[movieAuthors.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(lang).topMenu.movie), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.author_label), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.author_label), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).speakers, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "link line",
          to: _unref(links).author(item.id)
        }, {
          default: _withCtx(() => [
            _createVNode(Avatar, {
              url: item.thumb
            }, null, 8, ["url"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.author_recommend), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).movies, (item) => {
        return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
      }), 256))
    ])
  ]))
}
}

})